function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import LinkedModelsInfos from 'Components/LinkedModelsInfos';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import DefaultModal from 'Modals/DefaultModal';
numeral.locale('en');
moment.locale('fr');
const {
  qwest
} = window;
export default class ServiceTitleRow extends Component {
  state = {
    loading: false,
    openDeleteServiceTitleModal: false,
    status_messages: {},
    needs_confirmation: true
  };
  delete_ref = React.createRef();
  deleteServiceTitle = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.needs_confirmation) {
      return component.setState({
        needs_confirmation: false
      });
    }
    component.setState({
      loading: true
    });
    qwest.post('/servicetitle/delete', {
      id: state.delete_modal_servicetitle,
      confirmation: true
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      component.delete_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        }),
        linked_models: response.linked_models
      });
    });
  };
  openDeleteServiceTitleModal = ({
    servicetitle_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteServiceTitleModal: true,
      delete_modal_servicetitle: servicetitle_id,
      delete_modal_trigger: e.target,
      needs_confirmation: true,
      error: undefined,
      warning: undefined,
      statement: undefined,
      info: undefined,
      linked_models: {}
    });
  };
  closeDeleteModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteServiceTitleModal: false,
      delete_modal_servicetitle: undefined,
      delete_modal_trigger: undefined
    });
    props.requestUpdate();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    const blank_props = blank === true ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {};
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const link = /*#__PURE__*/React.createElement(Link, _extends({
      className: "u-link-only"
    }, blank_props, {
      href: URL('AdminServiceTitlesDashboard') + '/' + data.id
    }), "Page du titre de service");
    const has_linked_models = Object.keys(state.linked_models || {}).length > 0;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell ServiceTitle-title"
    }, data.title, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell ServiceTitle-category"
    }, data._category?.label, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell ServiceTitle-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      color: "primary",
      className: "c-dashboard__cell-info ",
      title: "Supprimer le titre",
      onClick: e => component.openDeleteServiceTitleModal({
        servicetitle_id: data.id,
        e: e
      })
    }, /*#__PURE__*/React.createElement(DeleteIcon, {
      color: "primary"
    }))), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openDeleteServiceTitleModal,
      title: "Suppression d'un titre de service",
      trigger_src: state.delete_modal_trigger,
      "close-ref": component.delete_ref,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeDeleteModal
    }, state.needs_confirmation ? /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--blue"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Supprimer ce titre de service\xA0?")) : has_linked_models === false ? /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Cette suppression est d\xE9finitive. Voulez-vous continuer\xA0?")) : undefined, getFormStatus(state), /*#__PURE__*/React.createElement(LinkedModelsInfos, {
      models: state.linked_models
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-15",
      disabled: has_linked_models,
      onClick: component.deleteServiceTitle
    }, state.needs_confirmation ? 'Supprimer' : 'Continuer et supprimer définitivement', loader), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.delete_ref?.current?.click()
    }, "Annuler"))));
    return output;
  }
}
